import { Card, CardBody, CardHeader } from "reactstrap";

export const CardUserNetwork = ({ network }) => {
  const isEmpty = !Array.isArray(network) || network.length === 0;

  return (
    <Card>
      <CardHeader>Red del Usuario</CardHeader>
      <CardBody>
        {isEmpty ? (
          <p className="text-muted mb-0">El usuario no tiene información de red.</p>
        ) : (
          network.map((n, index) => (
            <div key={n.id || index} style={{ marginBottom: "1rem" }}>
              <p><strong>ID Usuario:</strong> {n.user_id}</p>
              <p><strong>Estado Red:</strong> {n.network_status ? "Activo" : "Inactivo"}</p>
              <p><strong>Nivel:</strong> {n.level}</p>
              <hr />
            </div>
          ))
        )}
      </CardBody>
    </Card>
  );
};
